import { Typography } from '@mui/material'

import useStyles from './index.styles'

const Nh3Bubble = ({ value, isOffline }: { value: number; isOffline: boolean }) => {
  const classes = useStyles

  const offlineText = isOffline ? ' (Offline)' : ''
  const ariaLabel = `${value || 'Unknown'} PPM`

  return (
    <Typography variant="body1" color={isOffline ? 'divider' : 'textPrimary'} sx={classes.label} aria-label={`${ariaLabel}${offlineText}`}>
      {value || '--'}
      <Typography variant="caption" color={isOffline ? 'divider' : 'textPrimary'} sx={classes.ppmLabel}>
        PPM
      </Typography>
    </Typography>
  )
}

export default Nh3Bubble
